import { experiment } from "@faire/web--source/common/settings/declarations/experiment";
/**
 * XP to prefetch additional PDP APIs
 */ export var FE_PREFETCH_PDP_APIS_250224 = experiment({
    name: "FE_PREFETCH_PDP_APIS_250224",
    identifier: "RetailerTokenInSession",
    client: "RETAILER",
    notifyAfter: "2025-05-24",
    defaultValue: false,
    productArea: "PRODUCT_PAGE"
});
